const prefix = 'INVALID_ACCOUNT/';
export const SET = prefix + 'SET';
export const SET_PAYMENT = prefix + 'SET_PAYMENT';
export const SET_PAYMENT_CARD = prefix + 'SET_PAYMENT_CARD';
export const RESET = prefix + 'RESET';
